import React, { useEffect } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function BannerForm() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const sliderImages = [1, 2, 3, 4];

  const sliderSettings = {
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 700,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
  };

  return (
    <section
      className="banner-form"
      data-aos="fade-up"
      data-aos-delay="300"
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      {/* Slider as background */}
      <Slider {...sliderSettings} className="banner-form__carousel-wrapper">
        {sliderImages.map((img, idx) => (
          <div key={idx}>
            <div
              className="banner-form__image"
              style={{
                backgroundImage: `url(/assets/images/slider/${img}.webp?v=20260924)`,
                height: '100vh',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            ></div>
          </div>
        ))}
      </Slider>

      {/* Overlay Form */}
      <div
        className="banner-form__position"
        data-aos="fade-up"
        data-aos-delay="300"
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'flex-end', // changed from 'center'
        }}
      >
        <div className="container">
          <form
            className="banner-form__wrapper"
            action="https://live.ipms247.com/booking/book-rooms-hanthanahousekandy"
          >
            <div className="row">
              <div className="col-lg-4">
                <div className="banner-form__control">
                  <label htmlFor="checkin">Checkin</label>
                  <input
                    className="villoz-datepicker"
                    id="checkin"
                    type="text"
                    name="checkin"
                    placeholder="Add Date"
                  />
                  <i className="icon-calendar" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="banner-form__control">
                  <label htmlFor="checkout">Checkout</label>
                  <input
                    className="villoz-datepicker"
                    id="checkout"
                    type="text"
                    name="checkout"
                    placeholder="Add Date"
                  />
                  <i className="icon-calendar" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="banner-form__control" style={{ borderRight: 'none' }}>
                  <label htmlFor="guests">Guests</label>
                  <button type="submit" className="banner-form__qty-minus sub">
                    <i className="icon-minus-1" />
                  </button>
                  <input
                    id="guests"
                    type="number"
                    defaultValue={0}
                    name="guests"
                    placeholder="0"
                  />
                  <button type="submit" className="banner-form__qty-plus add">
                    <i className="icon-plus-1" />
                  </button>
                </div>
              </div>
              <div className="col-lg-2">
                <button
                  type="submit"
                  aria-label="search submit"
                  className="villoz-btn villoz-btn--base"
                >
                  <div className="banner-form_search">
                    <div className="search_n">
                      <label>Search</label>
                    </div>
                    <span>
                      <i className="icon-magnifying-glass" />
                    </span>
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default BannerForm;
